export namespace PREFERENCE_TYPE {
    export const  LISTING_CONTACTS = "listingContacts"
    export const  LISTING_CREDIT_MEMOS = "listingCreditMemos"
    export const  LISTING_COMPANIES= "listingCompanies"
    export const  LISTING_PRODUCTS = "listingProducts"
    export const  LISTING_STRUCTURES = "listingStructures"
    export const  LISTING_QUOTES = "listingQuotes"
    export const  LISTING_BUNDLES = "listingBundles"
    export const  LISTING_INVOICES = "listingInvoices"
    export const  LISTING_ORDERS = "listingOrders"
    export const  LISTING_RETURNS = "listingReturns"
    export const  LISTING_RECURRING_INVOICES = "listingRecurringInvoices"
    export const  LISTING_SCHEDULING_PAGES = "listingSchedulingPages"
    export const  LISTING_CALENDAR_EVENTS = "listingCalendarEvents"
    export const  LISTING_PAYMENTS = "listingPayments"
    export const  LISTING_PRICE_LISTS = "listingPriceLists"
    export const  LISTING_ADD_ITEM_QUOTES = "listingAddItemQuotes"
    export const  LISTING_ADD_ITEM_INVOICES = "listingAddItemInvoices"
    export const  LISTING_ADD_ITEM_PRICE_LISTS = "listingAddItemPriceLists"
    export const LISTING_ITEM_REPORTS = "listingItemReports"
    export const LISTING_ITEM_IMPORT_ADJUSTMENTS = "listingItemImportAdjustments"
    export const LISTING_STOCK_DOCUMENTS = "listingStockDocuments"
    export const LISTING_SUPPLIERS = "listingSuppliers"
    export const LISTING_STOCK_IMPORTS= "listingStockImports"
    export const LISTING_ACCOUNT_STATEMENTS = "listingAccountStatements"
}
export type PREFERENCE_TYPE = typeof PREFERENCE_TYPE[keyof typeof PREFERENCE_TYPE];


// WEBPACK FOOTER //
// ./src/state/listing/constants.ts